module.exports = __webpack_public_path__ + "media/images/paclistexample-ad009ada4dc4316152493ad05f9351ea.jpg";